import React  from 'react';
import {Route, IndexRoute} from 'react-router';
import Home from './components/Start';
import Surfaces from './components/Surfaces';
import Categories from './components/Categories';
import Options from './components/Options';
import ProductList from './components/ProductList';
import Choices from './components/Choices';
import Browse from './components/Browse';
import App from './components/App';
import Wrap from './components/Wrap';
import Container from './components/chunks/Container';

export default (
    <Route path="/" component={Wrap}>
        <IndexRoute component={Home} />
        <Route component={App}>
            <Route path="/product/:productSlug" component={ProductList} />
            <Route path="/:floorSurface/:category/:option/products" component={ProductList} />
            <Route component={Container}>
                <Route path="/surface" component={Surfaces} />
                <Route path="/choices/:floorSurface" component={Choices} />
                <Route path="/:floorSurface/options" component={Categories} />
                <Route path="/:floorSurface/:category" component={Options} />
                <Route path="/choices" component={Choices} />
                <Route path="/browse" component={Browse} />
            </Route>
        </Route>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js